import styled from 'styled-components';

export const StyledLabel = styled('label')`
    margin-bottom: 0;
`;
